import { dispatch } from '../store';
import { LOGOUT } from '../actions';
import conflicts from './confilct_errors';
import swal from '../utils/swal';

export const CODES = {
  INVALID_CREDINTIALS: 101,
  UNPROCESSED_ENTITY: 422,
  CONFLICT: 409,
  UNAUTHORUZED: 401,
  FORBIDDEN: 403,
  LOCKED: 423,
  SERVER_ERROR: 500,
  BAD_REQUEST: 400,
};

// BackOffice Error Handle Method
export default e => {
  function drawErrorList(errors) {
    const errs = Object.values(errors);
    const classname = 'error-msg-right';

    let dom = `<ul class="${classname}">`;
    errs.forEach(err => {
      dom += `<li>${err[0]}</li>`;
    });
    dom += '</ul>';

    return dom;
  }
  const error = e;
  const response = error && error.response;
  const data = response && response.data;
  const message = (data && data.message) || (data && data.error && data.error.message) || '';
  const loggedOut = () => {
    dispatch(LOGOUT());
    swal.fire({
      title: 'عذرا',
      text: 'يبدو أن فترة الجلسة انتهت، الرجاء اعادة تسجيل الدخول',
      type: 'warning',
    });
  };

  if (
    message &&
    (message.includes('User is not logged in') ||
      message.includes('Token is Expired') ||
      message.includes('Token has expired') ||
      message.includes('Unauthenticated'))
  ) {
    return loggedOut();
  }

  if (data && data.error) {
    if (
      message &&
      (message.includes('User is not logged in') ||
        message.includes('Token is Expired') ||
        message.includes('Token has expired') ||
        message.includes('Unauthenticated'))
    ) {
      return loggedOut();
    }
    if (data.error.code === CODES.INVALID_CREDINTIALS) {
      swal.fire({
        title: 'عذرا',
        text: 'البيانات المدخلة غير صحيحة، نرجو التأكد من صحة البيانات المدخلة',
        type: 'error',
      });
    }
    if (data.error.code === CODES.LOCKED) {
      swal.fire({
        title: 'عذرا',
        text: 'تم تعطيل الحساب، الرجاء التواصل مع مدير النظام',
        type: 'error',
      });
    }
    if (data.error.code === CODES.UNAUTHORUZED) {
      return loggedOut();
    }
    if (data.error.code === CODES.FORBIDDEN) {
      swal.fire({
        title: 'عذرا',
        text: 'لا يمكنك تنفيذ هذا الأمر',
        type: 'warning',
      });
    }
    if (data.error.code === CODES.UNPROCESSED_ENTITY || data.error.code === CODES.BAD_REQUEST) {
      let htmlMessage =
        response.data.error.message ||
        `الرجاء التأكد من المدخلات, ${response.errors ? response.errors.title[0] : ''}`;
      htmlMessage = htmlMessage.replace(/\./g, '</br>');
      swal.fire({
        title: 'عذرا',
        html: htmlMessage,
        type: 'warning',
      });
    }
    if (data.error.code === CODES.CONFLICT) {
      swal
        .fire({
          title: 'عذرا',
          text: conflicts[data.error.status] ? conflicts[data.error.status] : conflicts.GENERAL,
          type: 'warning',
        })
        .then(() => {
          if (!data.error.status === 'ACCESSING_A_PROCESSED_REQUEST') {
            window.location.reload();
          }
        });
    }
    if (data.error.code === CODES.SERVER_ERROR) {
      swal.fire({
        title: 'عذرا',
        text: 'حدث خطأ ما',
        type: 'warning',
      });
    }
  } else if (data && data.errors) {
    swal.fire({
      type: 'error',
      title: 'فضلا تأكد من صحة البيانات المقدمة',
      html: drawErrorList(data.errors),
    });
  } else {
    swal.fire({
      title: 'عذرا',
      text: 'حدث خطأ ما',
      type: 'warning',
    });
  }
  return error;
};
